/** Breadcrumb — page location indicator. */
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { cn } from "../../lib/cn";

export function Breadcrumb({ items = [], className }) {
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumb">
      <ol className={cn("flex flex-wrap items-center gap-2 text-[12.5px] font-mono uppercase tracking-[0.16em]", className)}>
        {items.map((it, i) => (
          <li key={i} className="flex items-center gap-2">
            {i > 0 && <ChevronRight size={12} className="text-text-faint" />}
            {it.to && i !== items.length - 1 ? (
              <Link to={it.to} className="text-text-dim hover:text-mauve transition-colors">
                {it.label}
              </Link>
            ) : (
              <span className={i === items.length - 1 ? "text-text" : "text-text-dim"}>
                {it.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
